import React from 'react';
import './App.css';
import HarryPotter from './views/HarryPotter.js'
import 'bootstrap/dist/css/bootstrap.min.css';
import {Navbar, Nav} from 'react-bootstrap'
import CharacterDetail from './views/CharacterDetail.js'
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch
} from 'react-router-dom'
import { Provider } from "react-redux";
import store from './store'
import FavoriteCharacter from './views/FavoriteCharacter.js'
function App() {
  return (
    <Provider store={store}>
      <div className="App" >
        <Router>
          <Navbar id="bg-color-navbar" expand="lg">
            <Navbar.Brand id="navbar"><img src="https://1000logos.net/wp-content/uploads/2017/02/Harry-Potter-Logo.png" style={{height:"50px"}} alt="logo"></img></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mr-auto">
                <Link style={{marginRight: "10px"}} to="/" id="navbar">List Characters</Link>
                <Link to="/favorites" id="navbar">Favorite Characters</Link>
                </Nav>
            </Navbar.Collapse>
          </Navbar>
          <Switch>
              <Route exact path="/">
                  <HarryPotter />
              </Route>
              <Route path="/favorites">
                <FavoriteCharacter />
              </Route>
              <Route path="/character/:id">
                <CharacterDetail />
              </Route>
          </Switch>
        </Router>
      </div>
    </Provider>
  );
}

export default App;
